<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<div class="card text-center" *ngIf="dataSource.data.length>0">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
     Spra Review List
    </div>
    <div class="card-body mat-card">
      <div class="row">

        <div class="col-sm-12">
          <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control" (keyup)="doFilter($event)" placeholder="Filter">
          </div>
        </div>

        <div class="col-sm-12">
          <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc">

             <!-- Position Column -->
             <ng-container matColumnDef="requestNo">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Request No </mat-header-cell>
              <mat-cell *matCellDef="let element" class="btn-link text-primary" (click)="onRequestClick(element)"> {{element.requestNo}} </mat-cell>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="saleCode">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Sale Code </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.saleCode}} </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="partyName">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Company Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.partyName}} </mat-cell>
            </ng-container>

           

             <!-- Position Column -->
             <ng-container matColumnDef="productCategory">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Product Category </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.productCategory}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
             <ng-container matColumnDef="saleType">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Type </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.saleType}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
             <ng-container matColumnDef="lastValidatedBy">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Review RequestedBy </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.lastValidatedBy}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="validatedate">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Validate Date </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                  {{element.validatedate}}                  
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="isRental">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Rental </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.isRental==true?'Yes':'No'}} </mat-cell>
                
              </ng-container>
          
          
            <mat-header-row *matHeaderRowDef="ValidationListAdminsalesHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ValidationListAdminsalesHeader;"></mat-row>
          </mat-table>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-6 float-right text-right">
            <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>